import { dollarFormatter, growthTrendFormatter } from "../../gridFormatters";

export const cloudResourceModelingDefs = [
	{
		"field": "resource_name",
		"headerName": "Resource Name",
	},
	{
		"field": "resource_type",
		"headerName": "Type",
	},
	{
		"field": "resource_location",
		"headerName": "Location",
	},
	// {
	// 	"field": "unit_of_measure",
	// 	"headerName": "Units (Meter)",
	// },
	{
		"field": "cost_per_unit",
		"headerName": "Cost per Unit",
		"cellRenderer": dollarFormatter,
	},
	{
		"field": "total_cost",
		"headerName": "Cost per Month",
		"cellRenderer": dollarFormatter,
	},
	{
		"field": "growth",
		"headerName": "Monthly Growth",
		"cellRenderer": growthTrendFormatter,
	},
]